/*

 _    _                  _             _ 
| |  | |                (_)           | |
| |  | | __ _ _ __ _ __  _ _ __   __ _| |
| |/\| |/ _` | '__| '_ \| | '_ \ / _` | |
\  /\  / (_| | |  | | | | | | | | (_| |_|
 \/  \/ \__,_|_|  |_| |_|_|_| |_|\__, (_)
                                  __/ |  
                                 |___/   

The following FAQ messages will be inserted using dangerouslySetInnerHTML() to allow for HTML formatting!
Any HTML will actually be rendered directly on the page. Be careful with this! Do not leave unclosed tags
and do not leave any malicious code in here or you will be sorry! >:) mwahahaha

*/


export const questions = [
    {
        id: 1,
        question: "What is the Partnered Program?",
        answer: "The Partnered Program is a white-label dedicated fractional services program. The program allows organizations to integrate top tier dedicated resources at a fraction of the cost."
    },
    {
        id: 2,
        question: "How can the Partnered Program benefit my organization?",
        answer: "By subscribing to the Partnered Program, you'll unlock access to top-tier Practitioners that will supercharge your organization's success. With our help, you can complete projects more efficiently, increase net margin, and propel your business forward."
    },
    {
        id: 3,
        question: "How does the Partnered Program compare in pricing? ",
        answer: "The Partnered Program offers top-tier fractional services with significant cost savings. We are 30% less expensive compared to hiring a W-2 employee. Our commitment to reducing project and operational overhead expenses by an average of 10% further showcases the value of our service."
    },
    {
        id: 4,
        question: "What types of Fractional Services do you provide?",
        answer: "By joining the Partnered Program you gain access to a team of highly skilled operators with over 30 years of combined experience. From fractional project management and operations to creative and technical execution, our experts bring the critical thinking and analytical skills necessary to tackle your most complex challenges. They will help you streamline processes, surface hidden risks and opportunities, and deliver outcomes that move the business forward — whether you're building something new or optimizing what already exists."
    },
    {
        id: 5,
        question: "Is there a minimum engagement length?",
        answer: "We have a 3 month minimum commitment because tangible results take more than a few weeks to surface. Three months is when our clients start seeing the ROI and operational impact that made them reach out in the first place. After that it's month to month, or you can save with a 6 or 12 month contract."
    },
    {
        id: 6,
        question: "What happens if I run out of hours? ",
        answer: "Nothing! There will be no service interuption. Additional hours beyond the allocated monthly limit will be invoiced at our Partnered hourly rate."
    },
    {
        id: 7,
        question: "Can I upgrade or downgrade my plan?",
        answer: "Yes, of course! The Partnered Program is built to scale with your organization and adjust to current company needs. Clients are able to change their plan before the 1st of each month."
    },
    {
        id: 8,
        question: "Can my plan be cancelled at any time? ",
        answer: "Yes, if you would like to cancel your account please email cancel@partneredmg.com with the associated email on the account. Your account will be canceled at the end of the next billing cycle."
    }
]